import React from 'react';
import {NavLink} from 'react-router-dom';
import DashboardCard from './DashboardCard';

const ActiveOrdersCard = ({ data }) => {
    if (!data) return null;

    const { active } = data;

    return (
        <DashboardCard
            title="Active Orders"
            icon="fas fa-film"
            action={{ to: '/orders', label: 'View all orders' }}
        >
            <div className="text-center mb-4">
                <div className="display-4 fw-bold text-primary">{active.total}</div>
                <div className="text-light">Total Active Orders</div>
            </div>

            {active.total > 0 ? (
                <div>
                    {active.playing > 0 && (
                        <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-dark rounded">
                            <div>
                                <span className="fas fa-play-circle text-success me-2" />
                                <NavLink to="/orders?status=playing" className="text-decoration-none text-light">
                                    Playing Now
                                </NavLink>
                            </div>
                            <span className="badge bg-success">{active.playing}</span>
                        </div>
                    )}

                    {active.readyToPlayback > 0 && (
                        <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-dark rounded">
                            <div>
                                <span className="fas fa-check-circle text-info me-2" />
                                <NavLink to="/orders?status=ready-to-playback" className="text-decoration-none text-light">
                                    Ready to Play
                                </NavLink>
                            </div>
                            <span className="badge bg-info">{active.readyToPlayback}</span>
                        </div>
                    )}

                    {active.preparingPlayback > 0 && (
                        <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-dark rounded">
                            <div>
                                <span className="fas fa-spinner text-warning me-2" />
                                <NavLink to="/orders?status=preparing-playback" className="text-decoration-none text-light">
                                    Preparing
                                </NavLink>
                            </div>
                            <span className="badge bg-warning text-dark">{active.preparingPlayback}</span>
                        </div>
                    )}
                </div>
            ) : (
                <div className="text-center text-light py-4">
                    <span className="fas fa-info-circle fs-3 d-block mb-2 text-muted" />
                    No active orders at this time
                </div>
            )}
        </DashboardCard>
    );
};

export default ActiveOrdersCard;
